var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabbarChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6414_3008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.06641 17.998H14.9121C16.9629 17.998 17.9785 16.9824 17.9785 14.9707V3.04688C17.9785 1.03516 16.9629 0.0195312 14.9121 0.0195312H3.06641C1.02539 0.0195312 0 1.02539 0 3.04688V14.9707C0 16.9922 1.02539 17.998 3.06641 17.998ZM3.08594 16.4258C2.10938 16.4258 1.57227 15.9082 1.57227 14.8926V3.125C1.57227 2.10938 2.10938 1.5918 3.08594 1.5918H14.8926C15.8594 1.5918 16.4062 2.10938 16.4062 3.125V14.8926C16.4062 15.9082 15.8594 16.4258 14.8926 16.4258H3.08594ZM7.92969 13.6328C8.25195 13.6328 8.52539 13.4766 8.7207 13.1738L13.1836 6.15234C13.3008 5.95703 13.418 5.74219 13.418 5.52734C13.418 5.08789 13.0273 4.80469 12.627 4.80469C12.373 4.80469 12.1289 4.96094 11.9434 5.24414L7.89062 11.748L5.9668 9.25781C5.73242 8.94531 5.51758 8.86719 5.25391 8.86719C4.82422 8.86719 4.49219 9.20898 4.49219 9.63867C4.49219 9.85352 4.58008 10.0586 4.7168 10.2441L7.09961 13.1738C7.34375 13.4961 7.60742 13.6328 7.92969 13.6328Z",
    fill: "#1D1E2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6414_3008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9785,
    height: 17.998,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabbarChecked);
export default __webpack_public_path__ + "static/media/tabbar-checked.39c5fb400be09132201e00a386e6899a.svg";
export { ForwardRef as ReactComponent };